/**
 * Omnibus: vysvětlení „Nejnižší cena za 30 dnů" na produktových kartách.
 *
 * Desktop (hover): plovoucí bublina připnutá k řádku, vykreslená v <body>
 * přes position: fixed — řádek má opacity .76 (product-price--unit), což
 * vytváří stacking context, ze kterého CSS ::after tooltip nemůže utéct
 * (překrývaly ho sousední karty a dědil průhlednost).
 * Touch: tap na řádek otevře bottom sheet zespodu obrazovky.
 *
 * Delegované eventy — funguje i pro karty donačtené JS (filtry kolekcí).
 */
(function () {
  var SEL = '[data-omnibus-tooltip]';
  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- desktop: plovoucí bublina ---------- */
  var tip;
  function ensureTip() {
    if (tip) return tip;
    tip = document.createElement('div');
    tip.className = 'omnibus-tooltip';
    tip.setAttribute('role', 'tooltip');
    document.body.appendChild(tip);
    return tip;
  }
  function showTip(target) {
    var t = ensureTip();
    t.textContent = '';
    var heading = target.getAttribute('data-omnibus-tooltip-heading');
    if (heading) {
      var h = document.createElement('strong');
      h.className = 'omnibus-tooltip__heading';
      h.textContent = heading;
      t.appendChild(h);
    }
    t.appendChild(document.createTextNode(target.getAttribute('data-omnibus-tooltip')));
    var vw = Math.max(window.innerWidth, 320); // ochrana proti degenerovanemu viewportu
    var width = Math.max(180, Math.min(300, vw - 16));
    t.style.width = width + 'px';
    t.classList.add('is-visible');
    var r = target.getBoundingClientRect();
    var top = r.top - t.offsetHeight - 10;
    if (top < 8) top = r.bottom + 10; // nevejde se nahoru -> pod řádek
    var left = Math.max(8, Math.min(r.left, vw - width - 8));
    t.style.top = top + 'px';
    t.style.left = left + 'px';
  }
  function hideTip() {
    if (tip) tip.classList.remove('is-visible');
  }

  /* ---------- touch: bottom sheet ---------- */
  var sheet, backdrop;
  function ensureSheet() {
    if (sheet) return sheet;
    backdrop = document.createElement('div');
    backdrop.className = 'omnibus-sheet-backdrop';
    sheet = document.createElement('div');
    sheet.className = 'omnibus-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML =
      '<button type="button" class="omnibus-sheet__close" aria-label="Zavřít">&times;</button>' +
      '<div class="omnibus-sheet__grabber"></div>' +
      '<p class="omnibus-sheet__heading"></p>' +
      '<p class="omnibus-sheet__text"></p>';
    document.body.appendChild(backdrop);
    document.body.appendChild(sheet);
    backdrop.addEventListener('click', closeSheet);
    sheet.querySelector('.omnibus-sheet__close').addEventListener('click', closeSheet);
    return sheet;
  }
  function openSheet(target) {
    ensureSheet();
    // nadpis z atributu (fallback: text řádku), tělo = vysvětlení
    var heading = target.getAttribute('data-omnibus-tooltip-heading') || target.textContent.replace(/\s+/g, ' ').trim();
    sheet.querySelector('.omnibus-sheet__heading').textContent = heading;
    sheet.querySelector('.omnibus-sheet__text').textContent = target.getAttribute('data-omnibus-tooltip');
    backdrop.classList.add('is-open');
    sheet.classList.add('is-open');
  }
  function closeSheet() {
    if (!sheet) return;
    backdrop.classList.remove('is-open');
    sheet.classList.remove('is-open');
  }

  /* ---------- delegované eventy ---------- */
  document.addEventListener('mouseover', function (e) {
    if (!hoverable || !e.target.closest) return;
    var el = e.target.closest(SEL);
    if (el) showTip(el);
  });
  document.addEventListener('mouseout', function (e) {
    if (!hoverable || !e.target.closest) return;
    if (e.target.closest(SEL)) hideTip();
  });
  window.addEventListener('scroll', hideTip, true);

  document.addEventListener('click', function (e) {
    if (hoverable || !e.target.closest) return;
    var el = e.target.closest(SEL);
    if (el) {
      e.preventDefault();
      e.stopPropagation();
      openSheet(el);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeSheet();
      hideTip();
    }
  });
})();
